import {formatNumberWithCommas} from './formatNumberWithCommas'

export function formatFileSize(sizeInBytes: number): string {
    const kb = Math.ceil(sizeInBytes / 1024)
    if (kb >= 1024) {
        return `${formatNumberWithCommas(Math.round(kb / 1024))}MB`
    }
    return `${formatNumberWithCommas(kb)}KB`
}

export function formatFileSizeFromKB(sizeInKB: number): string {
    return formatFileSize(sizeInKB * 1024)
}
